import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { pinService, PinStatus } from '../services/pinService';

interface RequirePinProps {
  children: React.ReactElement;
}

/**
 * Protected route wrapper that requires presentation PIN
 * Redirects to /present-pin if not authorized
 */
export const RequirePin: React.FC<RequirePinProps> = ({ children }) => {
  const [pinStatus, setPinStatus] = useState<PinStatus | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkPin();
  }, []);

  const checkPin = async () => {
    try {
      const status = await pinService.getStatus();
      setPinStatus(status);
    } catch (error) {
      setPinStatus({ authorized: false });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
        color: 'white',
        fontSize: '18px'
      }}>
        Checking access...
      </div>
    );
  }

  if (!pinStatus?.authorized) {
    // Redirect to PIN entry page
    return <Navigate to="/present-pin" replace />;
  }

  return children;
};
